import { useTheme } from '@simplywallst/ui-core';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { useEffect } from 'react';

export function AndroidInit() {
  const theme = useTheme();

  useEffect(() => {
    EdgeToEdge.setBackgroundColor({ color: theme.color.noir });
  }, [theme]);

  return null;
}
